'use strict';

import './libs/svg';
import 'jquery-visible';
import '../components/header-languages/header-languages'
import '../components/slider-border/slider-border';
import '../components/accordion/accordion';
import '../components/slider-brand/slider-brand';
import '../components/select/select';
import '../components/show-more-btn/show-more-btn';
import '../components/share/share';
import '../components/input/input-date';
import '../components/horizontal-tabs/horizontal-tabs';
import '../components/slider-history/slider-history';
import '../components/slider-grid/slider-grid';
import '../components/slider-cursor-buttons/slider-cursor-buttons';
import '../components/link-back/link-back';
import '../components/national-team-card/national-team-card';
import '../components/calendar-competition/calendar-competition';

import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';
import JustValidate from "just-validate";
import autosize from "autosize";
import IMask from "imask";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


function changeMenuOnScroll() {
	let header = document.querySelector('.header');
	if (header) {
		window.addEventListener('scroll', () => {
			let scrolled = window.pageYOffset;
			if (scrolled > 2) {
				header.classList.add('scrolled')
			} else {
				header.classList.remove('scrolled')
			}
		})
	}
}

changeMenuOnScroll();

// получение высоты шапки
function getHeaderHeight() {
	const headerHeight = document.querySelector('.header').offsetHeight;
	document
		.querySelector(':root')
		.style.setProperty('--header-height', `${headerHeight}px`);
}

document.addEventListener('DOMContentLoaded', () => {
	getHeaderHeight();
	initPageBurger();
	formValidation();
});

let swiperMain = new Swiper('.slider-main .swiper', {
	modules: [Pagination, Navigation, Autoplay],
	loop: true,
	slidesPerView: 'auto',
	paginationClickable: true,
	spaceBetween: 16,
	speed: 800,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true
	},
	navigation: {
		nextEl: '.slider-main__button_next',
		prevEl: '.slider-main__button_prev',
	},
	pagination: {
		el: '.slider-main .swiper-pagination',
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		1025: {
			slidesPerView: 1,
			spaceBetween: 40,
		}
	},
});

function initPageBurger() {
	const pageHeader = document.querySelector('.header');

	if (pageHeader) {
		const headerBurger = pageHeader.querySelector(".header__burger");
		headerBurger.addEventListener("click", () => {
			let bodyState = document.body.getAttribute("data-state");
			bodyState === "open-nav" ? (document.body.dataset.state = "") : (document.body.dataset.state = "open-nav");
			pageHeader.classList.add("transition");
			setTimeout(function () {
				pageHeader.classList.remove("transition");
			}, 900);
		});
	}
}

function formValidation() {
	const validationFormConfig = {
		errorFieldCssClass: 'input__input_invalid',
		errorLabelStyle: {},
		errorLabelCssClass: ['input__error-text'],
	};

	const form = document.querySelector('#contactForm');
	const phoneFields = document.querySelectorAll('input[type=tel]');

	if (phoneFields) {
		phoneFields.forEach((field) => {
			IMask(field, {
				lazy: true,
				mask: '+{7} (000) 000 00 00',
				prepare: function (appended, masked) {
					if (appended === '8' && masked.value === '') {
						return '+7';
					}
					return appended;
				},
			});
		});
	}

	if (form) {
		const actionUrl = form.getAttribute('action');
		const formValidate = new JustValidate(form, validationFormConfig);
		const formFields = form.querySelectorAll('input[required]');

		autosize(document.querySelector('textarea'));

		formValidate
			.addField("input[name='name']", [
				{
					rule: 'required',
					errorMessage: 'Обязательное поле',
				},
				{
					rule: 'minLength',
					value: 2,
					errorMessage: 'Значение слишком короткое',
				},
				{
					rule: 'maxLength',
					value: 50,
					errorMessage: 'Значение слишком длинное',
				},
			])
			.addField("input[name='phone']", [
				{
					rule: 'required',
					errorMessage: 'Обязательное поле',
				},
				{
					rule: 'customRegexp',
					value:
						/^(\+7)[\s-]\(([0-9]{3})\)[\s-]([0-9]{3})[\s-]([0-9]{2})[\s-]([0-9]{2})/gi,
					errorMessage: 'Некорректный формат',
				},
			])
			.addField("input[name='email']", [
				{
					rule: 'required',
					errorMessage: 'Обязательное поле',
				},
				{
					rule: 'email',
					errorMessage: 'Некорректный формат',
				},
			])
			.addField("input[name='type']", [
				{
					rule: 'required',
					errorMessage: 'Обязательное поле',
				},
				{
					rule: 'maxLength',
					value: 50,
					errorMessage: 'Значение слишком длинное',
				},
			])
			.addField("textarea[name='message']", [
				{
					rule: 'required',
					errorMessage: 'Обязательное поле',
				},
				{
					rule: 'maxLength',
					value: 500,
					errorMessage: 'Значение слишком длинное',
				},
			])
			.onSuccess(() => {
				const formData = new FormData(form);
				const plainFormData = Object.fromEntries(formData.entries());
				fetch(actionUrl, formSendConfig(plainFormData)).then((response) => {
					if (response.ok) {
						form.reset();
						createSuccessModal();
					} else {
						alert('Ошибка! Попробуйте повторить отправку формы позже.');
					}
				});
			});

		formFields.forEach((field) => {
			field.addEventListener('change', () => {
				formValidate.revalidateField(`input[name='${field.name}']`);
			});
		});

		function createSuccessModal() {
			const successModal = document.querySelector('#form-success')

			if (successModal) {
				const closeModalBtn = successModal.querySelector('.modal-close')

				closeModalBtn.addEventListener('click', () => {
					successModal.classList.remove('active')
				})

				successModal.classList.add('active')
			}
		}
	}
}

function formSendConfig(plainFormData) {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json;charset=utf-8',
		},
		body: JSON.stringify(plainFormData),
	};
}


// Параллакс ракетки главной страницы
if (document.querySelector("[data-parallax-racket-main]")) {
	gsap.utils.toArray("[data-parallax-racket-main]").forEach(container => {
		const img = container.querySelector("img");

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: container,
				scrub: true,
				pin: false,
				start: "top bottom",
				end: "top"
			}
		});

		tl.fromTo(img, {
			yPercent: 10,
		}, {
			yPercent: 0,
		});
	});
}

// Параллакс видео главной страницы
if (document.querySelector("[data-parallax-video]")) {
	gsap.to("[data-parallax-video]", {
		yPercent: 60,
		ease: "none",
		scrollTrigger: {
			trigger: ".main__top",
			scrub: true,
			pin: false,
			start: "top top",
		}
	});
}


// Параллакс ракеток страницы "О паделе"
if (document.querySelector("[data-parallax-racket-about]")) {
	gsap.utils.toArray("[data-parallax-racket-about]").forEach(container => {
		const img = container.querySelector("img");

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: ".about-padel__title",
				scrub: true,
				pin: false,
				start: "top top",
				end: "bottom",
			}
		});

		tl.fromTo(img, {
			yPercent: 5,
		}, {
			yPercent: -20,
		});
	});
}

// Параллакс изображений страницы "О паделе"
if (document.querySelector("[data-parallax-image-about]")) {
	gsap.utils.toArray("[data-parallax-image-about]").forEach(image => {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: image,
				scrub: true,
				pin: false,
				start: "top bottom",
				end: "bottom top",
			}
		});

		tl.fromTo(image, {
			yPercent: 20,
		}, {
			yPercent: -20,
		});
	});
}

// ф-я подставляющая текущий год
function setCurrentYear() {
	const yearContainers = document.querySelectorAll('.js-today-year');
	if (yearContainers.length > 0) {
		const currentYear = new Date().getFullYear();
		yearContainers.forEach(el => {
			el.innerText = `${currentYear} `
		})
	}
}

setCurrentYear()
